<div class="content-container mb-3">
    <div class="content">
        <div class="fw-bold mb-3">
            <label>
                <mwp-text-translate text="Select a Company" jsonKey="selectACompany" />
            </label>
        </div>
        <form [formGroup]="companyForm" class="pb-3">
            <div class="col-6">
                <mwp-companies-dropdown [form]="companyForm" [nameForControl]="'companyName'" [idForControl]="'companyID'" />
            </div>
        </form>
    </div>
    <div class="footer d-inline-flex justify-content-end w-100">
        <button class="mwp-button-secondary" (click)="cancel()">
            <mwp-text-translate text="Cancel" jsonKey="cancel" />
        </button>
        <button class="mwp-button ms-3" [disabled]="!companyForm.valid" (click)="save()">
            <mwp-text-translate text="Continue" jsonKey="continue" />
        </button>
    </div>
</div>